<template>
  <div class="flex h-full w-full flex-col items-center justify-center">
    <slot />
    <loader :is-loading="isLoading" />
    <img
      v-if="file.mimeType.includes('image')"
      class="h-auto max-h-full max-w-full"
      :src="file.url"
      alt="Document"
      loading="lazy"
    />
    <div
      v-else-if="file.mimeType.includes('pdf') && !isLoading"
      class="h-full w-full overflow-x-auto overflow-y-auto"
    >
      <pdf-embed
        :id="fileId"
        data-cy="embed-pdf"
        :file="file"
        :type="file.mimeType"
      />
    </div>
    <div
      v-if="!(file.mimeType.includes('image') || file.mimeType.includes('pdf'))"
      class="flex flex-col items-center justify-center"
    >
      <span>{{ $t("DEALS.DOCUMENTS.PREVIEW_UNSUPPORTED_1") }}</span>
      <span v-if="downloadable">
        {{ $t("DEALS.DOCUMENTS.PREVIEW_UNSUPPORTED_2") }}
      </span>
    </div>
    <span v-if="errorOccured">
      {{ $t("COMMON.ERROR_OCCURRED") }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from "vue";

import { axiosClient } from "@/services/client";

import PdfEmbed from "@/components/PdfEmbed.vue";

const props = defineProps({
  fileUrl: {
    type: String,
    required: true,
  },
  fileId: {
    type: [String, Number],
    required: false,
  },
  downloadable: {
    type: Boolean,
    default: true,
  },
  hideControls: {
    type: Boolean,
    default: false,
  },
});

const file = ref({
  mimeType: "",
  url: "",
});

const errorOccured = ref(false);
const isLoading = ref(true);

const getFile = async () => {
  errorOccured.value = false;
  isLoading.value = true;
  try {
    const response = await axiosClient.get(props.fileUrl, {
      baseURL: "",
      responseType: "blob",
    });
    const mimeType = response.headers["content-type"];
    const url = URL.createObjectURL(response.data);
    file.value = {
      url,
      mimeType,
    };
  } catch (error) {
    errorOccured.value = true;
    file.value = {
      mimeType: "",
      url: "",
    };
  } finally {
    isLoading.value = false;
  }
};

const refreshElement = () => {
  // embedded PDFs don't resize properly unless we force them to
  // changing width of container needs this to resize
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
  }, 100);
};

watch(() => props.fileUrl, getFile);
defineExpose({ refreshElement });

onMounted(getFile);

onUnmounted(() => {
  if (file.value.url) {
    URL.revokeObjectURL(file.value.url);
  }
});
</script>
